module.exports = __webpack_public_path__ + "fonts/UniversalSans-413.642aae3.otf";